module.exports = __webpack_public_path__ + "img/lierre.51290e14.jpg";